<div class="resume-screener-banner">
  <div class="screener-container">
    <div class="webbtree-logo">
      <img src="../../assets/webbtree-white.png" alt="">
    </div>
    <div class="headerText">
      <h1>Meet Webbtree’s AI Resume Screener – Smarter Than Your Average ATS</h1>
    </div>
    <div class="ai-insights-box">
        <div class="text-center">
          <i class="fa-solid fa-file-import"></i>
          <p class="insightText ">JD</p>
        </div>
        <span>+</span>
        <div class="text-center">
          <i class="fa-solid fa-file-pdf"></i>
          <p class="insightText">Resume</p>
        </div>
        <span>+</span>
        <div class="text-center">
          <i class="fa-solid fa-calendar-lines-pen"></i>
          <p class="insightText">Criteria</p>
        </div>
        <span>=</span>
        <div class="text-center">
          <img src="../../../assets/resume-screening/ai-insights.png" style="width: 18px; margin-bottom: 5px;" alt="">
          <!-- <i class="fa-solid fa-chart-user"></i> -->
          <p class="insightText">Insights</p>
        </div>
    </div>
    <a data-testid="auto-app-ai-resume-screener-a-1" class="ai-resume-screening-btn d-flex mx-auto" (click)="redirectDemo('one')" target="_blank">Book a Demo</a>
  </div>
</div>
<div class="page-body">
    <div class="page-title">
      <div class="screener-container">
        <h2>Shortlist the best resumes for any job in seconds</h2>
        <p>Upload your job description, list evaluation criteria, and let our AI do the rest.</p>
      </div>
    </div>
    <div class="mb-5 form-component">
      <app-ai-resume-form (fetchCandidateEvent)="getAICandidate($event)"></app-ai-resume-form>
    </div>
    <div class="mb-5 form-component" id="user">
      <app-userprofile [resumePayload]="resumeAIPayload"></app-userprofile>
    </div>
     <div class="middle-banner2 scrrener">
      <div class="screener-container">
        <!-- <div class="middle-content">
        <p class="new-content mb-4">Impressed with the results? We integrate with 60+ ATS and help you save 90% screening time — Want to explore further?</p>
          <a data-testid="auto-app-ai-resume-screener-a-2" class="ai-resume-screening-btn d-flex mx-auto"  href="https://calendly.com/customer-success-webbtree/30min" target="_blank">Book a Demo</a>
        </div> -->
        <div class="screeningtime">
          <div class="screentime-content">
              <div class="screen-main-content">
                We integrate with 40+ ATS and help you save 90% screening time
              </div>
              <div class="screen-second-content">
                Want to explore further?
              </div>
          </div>
          <div class="screentime-bookdemo">
            <a data-testid="auto-app-ai-resume-screener-a-3" class="ai-resume-screening-btn d-flex" (click)="redirectDemo('two')"  target="_blank">Book a Demo</a>
          </div>
        </div>
      </div>
    </div>
    <div class="easy-step-box">
      <div class="screener-container">
        <h2>Evaluate Resumes in 4 Easy Steps</h2>
        <div class="xs-scrollable-div">
          <div class="d-flex step-conatiner">
            <div class="easy-step-card">
              <div>
                <i class="fa-solid fa-file-import"></i>
                <i class="fa-light fa-file-import"></i>
                <p class="steps">STEP 1</p>
                <p class="step-text">Upload Your JD</p>
              </div>
              <div style="width: 65%;">
                <span class="learnmore">Just paste or upload the JD.</span>
              </div>
            </div>
            <div class="easy-step-card">
              <div>
                <i class="fa-solid fa-calendar-lines-pen"></i>
                <i class="fa-light fa-calendar-lines-pen"></i>
                <p class="steps">STEP 2</p>
                <p class="step-text">Upload Resumes</p>
              </div>
              <div style="width: 90%;">
                <span class="learnmore">Upload up to 10 resumes in PDF format.</span>
              </div>
            </div>
            <div class="easy-step-card">
              <div>
                <i class="fa-solid fa-stars"></i>
                <i class="fa-light fa-stars"></i>
                <p class="steps">STEP 3</p>
                <p class="step-text">Add Evaluation Criteria</p>
              </div>
              <div style="width: 80%;">
                <span class="learnmore">Add Min 1 or max 5 criteria</span>
              </div>
            </div>
            <div class="easy-step-card">
              <div>
                <i class="fa-solid fa-id-card"></i>
                <i class="fa-light fa-id-card"></i>
                <p class="steps">STEP 4</p>
                <p class="step-text">Get Instant Insights</p>
              </div>
              <div>
                <span class="learnmore">See which candidates match and why.</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="powerby-adv-ai-card">
      <div class="screener-container">
        <div class="row flex-column-reverse flex-sm-row">
          <div class="col-md-6 d-flex align-items-center">
            <div>
              <div class="d-flex mb-6 position-relative">
                <span class="f-14 font-weight-400 line-height-1" style="color: #000;">Powered by advanced AI models</span>
                <div class="ai-icon-stack ml-3">
                  <div class="ai-icons chtgpt">
                    <img src="../../../assets/resume-screening/chatgpt.png" alt="">
                  </div>
                  <div class="ai-icons ai-icon2">
                    <img src="../../../assets/resume-screening/ai-icon2.png" alt="">
                  </div>
                </div>
              </div>
              <div class="mb-5">
                <p class="f-24 font-weight-600 mb-1">Intelligent Screening. </p>
                <p class="f-24 font-weight-600 mb-3">Instant Results.</p>
              </div>
              <div>
                <p class="f-14 font-weight-400 mb-2" style="color: #0000008C; line-height: 1.5;">Not your average resume filter—Webbtree’s AI Resume Screener goes far beyond traditional ATS tools.</p>
                <p class="f-14 font-weight-400 mb-3" style="color: #0000008C; line-height: 1.5;">Powered by advanced AI models (like Llama, OpenAI/ChatGPT, etc.), it doesn’t just scan resumes—it understands them.</p>
                <p class="f-14 font-weight-400 mb-2" style="color: #0000008C; line-height: 1.5;">Our AI interprets the story behind each profile, evaluates relevance based on your job requirements, and ranks candidates with recruiter-like precision. It’s like having a seasoned hiring expert working for you—instantly.</p>
              </div>
            </div>
          </div>
          <div class="col-md-6 mb-5">
            <div class="img-card">
              <!-- <img src="../../../assets/resume-screening/ai-powered.png" class="img-fluid" alt=""> -->
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="middle-banner">
      <div class="screener-container">
        <div class="middle-content">
        <p>Because great talent isn’t found through  keywords. It’s
          discovered through context</p>
        </div>
      </div>
    </div>
    <div class="try-this-box">
      <div class="screener-container">
        <h2> Why Try This?</h2>

        <div class="d-flex flex-wrap justify-content-center">
          <div class="try-this-card">
          <span><img src="../../../assets/resume-screening/Instantfitinsights.svg" alt=""></span>
          <div class="try-header">
            Instant fit insights
          </div>
          <div class="content">
            Automate evaluations faster than traditional methods.
          </div>
        </div>
        <div class="try-this-card">
        <span><img src="../../../assets/resume-screening/Alignedwithhiringneeds.svg" alt=""></span>
          <div class="try-header">
            Aligned with hiring needs
          </div>
          <div class="content">
            Matches based on your actual role requirements.
          </div>
        </div>
        <div class="try-this-card">
          <span><img src="../../../assets/resume-screening/Recruiter-Tested.svg" alt=""></span>
          <div class="try-header">
            Recruiter-Tested
          </div>
          <div class="content">
            Built with feedback from 400+ real hiring professionals.
          </div>
        </div>
        <div class="try-this-card">
          <span><img src="../../../assets/resume-screening/Savescreeningtime.svg" alt=""></span>
          <div class="try-header">
          Save 90% screening time
          </div>
          <div class="content">
            Automate evaluations faster than traditional methods.
          </div>
        </div>
        <div class="try-this-card">
        <span><img src="../../../assets/resume-screening/TransparentScoring.svg" alt=""></span>
          <div class="try-header">
          Transparent Scoring
          </div>
          <div class="content">
            See how and why a candidate ranks high or low.
          </div>
        </div>
        <div class="try-this-card">
        <span><img src="../../../assets/resume-screening/ContextualMatching.svg" alt=""></span>
          <div class="try-header">
          Contextual Matching
          </div>
          <div class="content">
          Goes beyond keywords to understand actual fit.
          </div>
        </div>
        </div>
      </div>
    </div>
</div>
<div class="page-footer">
  <div class="screener-container">
    <div class="footer-content">
      <h1>Ready to See the Power of Webbtree AI Screener?</h1>
      <p>Upload a JD. Upload resumes. Watch the magic happen.</p>
      <p>Love what you see? Sign up to unlock unlimited usage, advanced analytics, and ATS integrations.</p>
      <!-- <form [formGroup]="freeTrialForm">
      <div class="col-md-6 mx-auto emailForm">
        <div class="w-100">
          <input data-testid="auto-app-ai-resume-screener-input-1" type="email" id="workemail" formControlName="workEmail" placeholder="Enter your work email" class="wc-form-control">
        </div>
        <button data-testid="auto-app-ai-resume-screener-button-1" class="ai-resume-screening-btn" (click)="freeTrialForm()">Try for Free</button>
      </div>
      </form> -->
      <a data-testid="auto-app-ai-resume-screener-a-4" class="ai-resume-screening-btn"  (click)="redirectDemo('three')"  target="_blank">
        Book a Demo
      </a>

    </div>
  </div>
</div>
